module.exports = __webpack_public_path__ + "static/media/gmail-logo.828e4779.png";